import React, { useRef, useImperativeHandle, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import './RichTextEditor.css'

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"]
  ],
};

// 🔥 simple formatter (beautify HTML)
const formatHTML = (html) => {
  if (!html) return "";

  return html
    .replace(/></g, ">\n<") // new line between tags
    .replace(/(<\/\w+>)/g, "$1\n") // closing tag line break
    .trim();
};

const RichTextEditor = React.forwardRef(({ value, onChange, ...props }, ref) => {
  const quillInstanceRef = useRef(null);
  const [isSourceMode, setIsSourceMode] = useState(false);

  useImperativeHandle(ref, () => ({
    focus: () => quillInstanceRef.current?.focus(),
    getEditor: () => quillInstanceRef.current?.getEditor(),
  }));

  return (
    <div className="rich-editor-wrapper">

      {/* 🔥 Toolbar */}
      <div className="editor-header">
        <button
          type="button"
          className={`toggle-btn ${!isSourceMode ? "active" : ""}`}
          onClick={() => setIsSourceMode(false)}
        >
          ✨ Visual
        </button>

        <button
          type="button"
          className={`toggle-btn ${isSourceMode ? "active" : ""}`}
          onClick={() => setIsSourceMode(true)}
        >
          {"</>"} Code
        </button>
      </div>

      {/* 🔥 Editor */}
      {/* {isSourceMode ? (
        <Code
          value={formatHTML(value)}
          onChange={(e) => onChange(e.target.value)}
          className="code-editor"
        />
      ) : ( */}
      {isSourceMode ? (
        <div className="card shadow-sm">
          <div className="card-header d-flex justify-content-between align-items-center">
            <span className="fw-bold">HTML Source Code</span>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => navigator.clipboard.writeText(value)}
            >
              Copy
            </button>
          </div>
          <div className="card-body p-0">
            <pre className="mb-0">
              <code
                contentEditable
                suppressContentEditableWarning
                className="d-block p-3 code-editor"
                style={{
                  minHeight: "300px",
                  fontFamily: "monospace",
                  background: "#0f172a",
                  color: "#e2e8f0",
                  outline: "none"
                }}
                onInput={(e) => onChange(e.currentTarget.textContent)}
              >
                {formatHTML(value)}
              </code>
            </pre>
          </div>
        </div>
      ) : (
        <ReactQuill
          ref={quillInstanceRef}
          theme="snow"
          value={value || ""}
          onChange={onChange}
          modules={modules}
          className="quill-editor"
          {...props}
        />
      )}
    </div>
  );
});

export default RichTextEditor;